module.exports = __webpack_public_path__ + "static/media/Old_book.160e235e.png";